import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "children", "onClick", "seconds"];
import React, { useState, useEffect, useImperativeHandle } from 'react';
import classnames from 'classnames';
const Ticktock = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    className,
    children,
    onClick: propsOnClick,
    seconds = 60
  } = props,
        others = _objectWithoutProperties(props, _excluded);

  const [ticking, setTicking] = useState(false);
  const [count, setCount] = useState(seconds);
  const cls = classnames({
    'components-ticktock-render': true,
    'ticktock-ticking': !!ticking,
    [className]: !!className
  });

  const onClick = e => {
    !ticking && propsOnClick && propsOnClick(e);
  };

  const renderContent = () => {
    if (ticking) {
      return `${count}秒`;
    }

    return children;
  };

  useImperativeHandle(ref, () => ({
    start: () => {
      setTicking(true);
    }
  }));
  useEffect(() => {
    if (!ticking) {
      setCount(seconds);
    } else if (count > 0) {
      setTimeout(() => {
        setCount(count - 1);
      }, 1000);
    } else {
      setTicking(false);
    }
  }, [ticking, count, seconds]);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: cls,
    onClick: onClick
  }, others), renderContent());
});
Ticktock.defaultProps = {
  seconds: 60,
  onClick: undefined
};
export default Ticktock;